module.exports = __webpack_public_path__ + "static/gi-3851f858796b9be53e2710097b25b7ea.png";